import { STORE_FTL_COSTS, STORE_SHIPPING_COSTS } from '../../constants/ftlCosts';

const initialState = {
    ftlCosts: [],
    shippingCosts: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_FTL_COSTS:
            return {
                ...state,
                ftlCosts: action.ftlCosts
            }
        case STORE_SHIPPING_COSTS:
            return {
                ...state,
                shippingCosts: action.shippingCosts
        }
        default:
            return state;
    }
}